import { render, staticRenderFns } from "./ImportantConditionsTpl.vue?vue&type=template&id=b6f1270a&scoped=true"
import script from "./ImportantConditionsTpl.vue?vue&type=script&lang=js"
export * from "./ImportantConditionsTpl.vue?vue&type=script&lang=js"
import style0 from "./ImportantConditionsTpl.vue?vue&type=style&index=0&id=b6f1270a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f1270a",
  null
  
)

export default component.exports